<template>
<router-view />
</template>

<script>
export default {
  name: 'DataDisplayVerticalDetection',
  routeInfo: {
    label: '垂直探测',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/index.vue